import { ADJUSTER_REPORT_DAMAGED_PATHS } from '@/modules/adjusterReportModules/adjusterReport/links/damaged/damagedLinks';
import DamagedImageFlow from '@/modules/adjusterReportModules/IncidentParticipants/components/damaged/propertyDamage/images/DamagedImageFlow';
import DamagedListPage from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/damageList/DamagedListPage';
import AdjusterAttachedImages from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/propertyDamage/images/adjusterImages/AccidentAttachments/AdjusterAttachedImages';
import ShowAdjusterAttachedImages from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/propertyDamage/images/adjusterImages/AccidentAttachments/ShowAdjusterAttachedImages';
import AdjusterDocumentsImages from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/propertyDamage/images/adjusterImages/documentImages/AdjusterDocumentsImages';
import ShowAdjusterDocumentImages from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/propertyDamage/images/adjusterImages/documentImages/ShowAdjusterDocumentImages';
import OtherDamagedDescription from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/propertyDamage/images/adjusterImages/otherDamaged/otherDamagedDescription/OtherDamagedDescription';
import OtherDamagedImages from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/propertyDamage/images/adjusterImages/otherDamaged/otherDamagedImages/OtherDamagedImages';
import ShowOtherDamagedImages from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/propertyDamage/images/adjusterImages/otherDamaged/showOtherDamagedImages';
import DamagedPoints from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/propertyDamage/images/adjusterImages/vehicleImages/damagedPoints/DamagedPoints';
import FlowGuidePage from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/propertyDamage/images/adjusterImages/vehicleImages/flowGuide/FlowGuidePage';
import DamagedImagePreviewDamagedPoints from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/propertyDamage/images/adjusterImages/vehicleImages/imagePreviewDamagedPoints/DamagedImagePreviewDamagedPoints';
import VehicleDamageImagePreviewPage from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/propertyDamage/images/adjusterImages/vehicleImages/vehicleDamageImagePreview/vehicleDamageImagePreview';
import DamagedVehicleImagesShow from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/propertyDamage/images/adjusterImages/vehicleImages/vehicleDamageServerImagePreview/DamagedVehicleImagesShow';
import DamagedVehicleImagesShowEditable from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/propertyDamage/images/adjusterImages/vehicleImages/vehicleDamageServerImagePreview/DamagedVehicleImagesShowEditable';
import DamagedCorrectiveImages from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/propertyDamage/images/correctiveImages/DamagedCorrectiveImages';
import CustomerAttachedImages from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/propertyDamage/images/customerImages/CustomerAttachedImages';
import CustomerDocumentsImages from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/propertyDamage/images/customerImages/CustomerDocumentsImages';
import CustomerImagesTabs from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/propertyDamage/images/customerImages/CustomerImagesTabs';
import CustomerOtherImagesTab from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/propertyDamage/images/customerImages/CustomerOtherImagesTab';
import VehicleImages from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/propertyDamage/images/customerImages/VehicleImages';
import DamagedTabImages from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/propertyDamage/images/damagedTabImages/DamagedTabImages';
import DamagedSignaturePage from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/propertyDamage/images/signature/DamagedSignaturePage';
import ShowOfflineImages from '@/modules/OfflineFiles/pages/ShowOfflineImages';
import { Outlet, RouteObject } from 'react-router-dom';

const CUSTOMER_IMAGES_ROUTES: RouteObject[] = [
  {
    path: ADJUSTER_REPORT_DAMAGED_PATHS.IMAGES.CUSTOMER.base,
    element: <Outlet />,
    children: [
      {
        index: true,
        element: <CustomerImagesTabs />,
      },
      {
        path: ADJUSTER_REPORT_DAMAGED_PATHS.IMAGES.CUSTOMER.document,
        element: <CustomerDocumentsImages />,
      },
      {
        path: ADJUSTER_REPORT_DAMAGED_PATHS.IMAGES.CUSTOMER.additional,
        element: <CustomerAttachedImages />,
      },
      {
        path: ADJUSTER_REPORT_DAMAGED_PATHS.IMAGES.CUSTOMER.vehicleImages,
        element: <VehicleImages />,
      },
      {
        path: ADJUSTER_REPORT_DAMAGED_PATHS.IMAGES.CUSTOMER.otherDamaged,
        element: <CustomerOtherImagesTab />,
      },
    ],
  },
];

const VEHICLE_IMAGES_ROUTES: RouteObject[] = [
  {
    path: ADJUSTER_REPORT_DAMAGED_PATHS.IMAGES.ADJUSTER.VEHICLE.base,
    children: [
      {
        element: <DamagedPoints />,
        index: true,
      },
      {
        path: ADJUSTER_REPORT_DAMAGED_PATHS.IMAGES.ADJUSTER.VEHICLE
          .previewImageDamagePoint,
        element: <DamagedImagePreviewDamagedPoints />,
      },
      {
        path: ADJUSTER_REPORT_DAMAGED_PATHS.IMAGES.ADJUSTER.VEHICLE
          .takePhotoGuide,
        element: <FlowGuidePage />,
      },
      {
        path: ADJUSTER_REPORT_DAMAGED_PATHS.IMAGES.ADJUSTER.VEHICLE
          .takePhotoFlow,
        element: <DamagedImageFlow />,
      },
      {
        path: ADJUSTER_REPORT_DAMAGED_PATHS.IMAGES.ADJUSTER.VEHICLE
          .previewImages,
        element: <VehicleDamageImagePreviewPage />,
      },
      {
        path: ADJUSTER_REPORT_DAMAGED_PATHS.IMAGES.ADJUSTER.VEHICLE
          .editablePreviewImages,
        element: <DamagedVehicleImagesShowEditable />,
      },
      {
        path: ADJUSTER_REPORT_DAMAGED_PATHS.IMAGES.ADJUSTER.VEHICLE
          .showPreviewImages,
        element: <DamagedVehicleImagesShow />,
      },
      {
        path: ADJUSTER_REPORT_DAMAGED_PATHS.IMAGES.ADJUSTER.VEHICLE
          .offlineImages,
        element: <ShowOfflineImages />,
      },
    ],
  },
];

const ADJUSTER_IMAGES_ROUTES: RouteObject[] = [
  {
    path: ADJUSTER_REPORT_DAMAGED_PATHS.IMAGES.ADJUSTER.base,
    element: <Outlet />,
    children: [
      {
        path: ADJUSTER_REPORT_DAMAGED_PATHS.IMAGES.ADJUSTER.DOCUMENT.edit,
        element: <AdjusterDocumentsImages userType="damaged" />,
      },
      {
        path: ADJUSTER_REPORT_DAMAGED_PATHS.IMAGES.ADJUSTER.DOCUMENT.show,
        element: <ShowAdjusterDocumentImages userType="damaged" />,
      },
      {
        path: ADJUSTER_REPORT_DAMAGED_PATHS.IMAGES.ADJUSTER.ADDITIONAL.edit,
        element: <AdjusterAttachedImages />,
      },
      {
        path: ADJUSTER_REPORT_DAMAGED_PATHS.IMAGES.ADJUSTER.ADDITIONAL.show,
        element: <ShowAdjusterAttachedImages />,
      },
      {
        path: ADJUSTER_REPORT_DAMAGED_PATHS.IMAGES.ADJUSTER.OTHER_ADDITIONAL,
        element: <AdjusterAttachedImages />,
      },
      {
        path: ADJUSTER_REPORT_DAMAGED_PATHS.IMAGES.ADJUSTER.OTHER_DAMAGED.show,
        element: <ShowOtherDamagedImages />,
      },
      {
        path: ADJUSTER_REPORT_DAMAGED_PATHS.IMAGES.ADJUSTER.OTHER_DAMAGED.edit,
        children: [
          {
            index: true,
            element: <OtherDamagedDescription />,
          },
          {
            path: ADJUSTER_REPORT_DAMAGED_PATHS.IMAGES.ADJUSTER.OTHER_DAMAGED
              .images,
            element: <OtherDamagedImages />,
          },
        ],
      },
      ...VEHICLE_IMAGES_ROUTES,
    ],
  },
];

export const ADJUSTER_REPORT_DAMAGED_IMAGES_ROUTES: RouteObject[] = [
  {
    path: ':damagedId',
    children: [
      {
        index: true,
        element: <DamagedTabImages />,
      },
      {
        path: ADJUSTER_REPORT_DAMAGED_PATHS.IMAGES.SIGNATURE.edit,
        element: <DamagedSignaturePage editable />,
      },
      {
        path: ADJUSTER_REPORT_DAMAGED_PATHS.IMAGES.SIGNATURE.show,
        element: <DamagedSignaturePage editable={false} />,
      },
      {
        path: ADJUSTER_REPORT_DAMAGED_PATHS.IMAGES.corrective,
        element: <DamagedCorrectiveImages />,
      },
      ...ADJUSTER_IMAGES_ROUTES,
      ...CUSTOMER_IMAGES_ROUTES,
    ],
  },

  {
    path: ADJUSTER_REPORT_DAMAGED_PATHS.IMAGES.list,
    element: <DamagedListPage state="images" />,
  },
];
